<!-- 批量修改溯源码 -->
<template>
    <div class="container">
        <div class="content">
            <Form :model="formData" label-position="right" :label-width="150">
                <FormItem label="选择关联批次：">
                    <Select class="w300" v-model="formData.batch_id" clearable filterable placeholder="请选择">
                        <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content"><p>选择批次，没有请先在【批次管理】中【新增批次】</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择关联产品：">
                    <Select class="w300" v-model="formData.product_id" clearable filterable placeholder="请选择">
                        <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24"  type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content"><p>选择关联的产品，将会修改关联该产品的溯源码</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择所属代理商：">
                    <Select class="w300" v-model="formData.agent_id" clearable filterable placeholder="请选择">
                        <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.agent_name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24"  type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content"><p>选择默认所属的代理商，不选则暂时为空</p></div>
                    </Tooltip>
                </FormItem>
                <FormItem label="生产时间：">
                    <DatePicker class="w300" :value="formData.productive_time" type="date" placeholder="点击选择时间" @on-change="changeProductiveTime"></DatePicker>
                </FormItem>
                <FormItem label="过期时间：">
                    <DatePicker class="w300" :value="formData.expiration_date" type="date" placeholder="点击选择时间" @on-change="changeExpirationDate"></DatePicker>
                </FormItem>
                <FormItem label="是否启用：">
                    <i-switch v-model="formData.status" size="large" true-color="#FF761D" :true-value="1" :false-value="2">
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <div class="footer">
                    <Button class="theme-bc" type="warning" @click="submitForm">确定</Button>
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
import { 
    qrcode_batch_edit,
} from '@/api/index';
import { product_select, batch_select, agent_select } from '@/api/select';
export default {
    data() {
        return {
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                status: 2,
                productive_time: "",
                expiration_date: "",
            },
            batchList: [],
            productList: [],
            agentList: [],
        };
    },
    mounted() {
        this.getProductSelect();
        this.getBatchSelect();
        this.getagentSelect();
    },
    methods: {
        changeProductiveTime(e){
            if(e){
                this.formData.productive_time = e;
            }else {
                this.formData.productive_time = '';
            }
        },
        changeExpirationDate(e){
            if(e){
                this.formData.expiration_date = e;
            }else {
                this.formData.expiration_date = '';
            }
        },
        // 下拉
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getagentSelect(){
            agent_select().then((res) => {
                this.agentList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        submitForm(){
            qrcode_batch_edit(this.formData).then(res=>{
                this.formData.batch_id = "";
                this.formData.product_id = "";
                this.formData.agent_id = "";
                this.formData.status = 2;
                this.formData.productive_time = "";
                this.formData.expiration_date = "";
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.footer {
    margin: 24px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
</style>